import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
  animations: [
    trigger('menu', [
      transition(':enter', [
        style({'transform': 'translateX(-100%)'}),
        animate('.3s ease', style({'transform': 'translateX(0)'}))
      ]),
      transition(':leave', [
        style({'transition': 'translateX(0)'}),
        animate('.3s ease', style({'transform': 'translateX(-100%)'}))
      ])
    ])
  ]
})
export class HeaderBarComponent implements OnInit {

  @Output() sideMenuClick = new EventEmitter<boolean>(false)
  @Input() displayMenu: boolean = false; 
  @Input() headerImgClasses: boolean = false; 
  @Input() bgClass: boolean = false; 

  constructor() { }

  ngOnInit(): void {
  }

  toggleMenu(event: boolean) {
    this.sideMenuClick.emit(event);
  }

}
